module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av402-9020407e0b6bfd532172a9b6c97b2233.jpg";